// Add your JS customizations here
jQuery(document).ready(function ($) {

    $('body').addClass('active');


    //VARIABLES
    // var mainNavHeight = $('#main-nav').outerHeight(true);
    var wSize = $(window).width();

    var menu_bar = $('.navbar');
    var modal = $('.modal-menu');

    /*
    // Mobile 
    if (wSize >= 991.8) {
        $(modal).css('top', menu_bar_h);
        $(hero).css('margin-top', menu_bar_h);
    }
    $('.bg-overlay').css('top', menu_bar_h);
    $(window).on('scroll', function () {
        modal = $('.modal-menu'),
            hero = $('.hero'),
            menu_bar_h = $(menu_bar).outerHeight(true)
        if (wSize >= 991.8) {
            $(modal).css('top', menu_bar_h);
            $(hero).css('margin-top', menu_bar_h);
        }
 
    });
    */

    $('.matchheight').matchHeight();

    //inizialize WOW
    new WOW().init();

    //enables Font Awesome pseudo elements
    window.FontAwesomeConfig = {
        searchPseudoElements: true
    }

    //Products filter for Isotope
    function filter() {

        //  $('html, body').animate({scrollTop: '0px'});

        $('.category-grid').addClass('loading');

        setTimeout(function () {
            $('.loading-wrapper').fadeIn(250);
        }, 250);

        setTimeout(function () {
            $('.loading-wrapper').fadeOut(250);
        }, 2750);

        setTimeout(function () {
            $('.category-grid').removeClass('loading');
            $('.category-grid').isotope({

                filter: function () {
                    // Brand Filter
                    var brand = $(this).data('brand');
                    var brand_filter = $('.brand-filter').val();

                    if (brand_filter == 'all') {
                        var brand_status = true;

                    } else {
                        if ($(this).length > 0) {
                            var brand_filter = brand_filter.split(',');

                            if ($.inArray(brand, brand_filter) !== -1) {
                                var brand_status = true;
                            } else {
                                var brand_status = false;
                            }
                        }
                    }


                    //Category Filter
                    var category_filter = $('.category-filter').val();
                    if (category_filter == 'all') {
                        var category_status = true;

                    } else {
                        if ($(this).length > 0) {
                            var categories = $(this).data('categories').split(',');

                            if ($.inArray(category_filter, categories) !== -1) {
                                var category_status = true;
                            } else {
                                var category_status = false;
                            }
                        }
                    }

                    // Price Filter 
                    var price = parseFloat($(this).data('price'));
                    var price_filter_lower = parseFloat($('.price-filter-lower').val());
                    var price_filter_upper = parseFloat($('.price-filter-upper').val());

                    if ((price_filter_lower <= price) && (price <= price_filter_upper)) {
                        var price_status = true;
                    } else {
                        var price_status = false;
                    }

                    // Overall Filter Status
                    if (brand_status == true && category_status == true && price_status == true) {
                        return true;
                    } else {
                        return false;
                    }
                }
            });

            if ($('.category-grid').data('isotope').filteredItems.length == 0) {
                $('.category-grid').css('height', $('.category-grid .no-items-found').outerHeight(true));
                $('.category-grid .no-items-found').addClass('active');
            } else {
                $('.category-grid .no-items-found').removeClass('active');
            }

        }, 3000);

    }

    // Desktop Menu
    $('#main-menu li.open-sub a').click(function (e) {
        e.preventDefault(e);
        $('.modal-menu').removeClass('open');

        var target = $(this).attr('href');

        $('html').addClass('modal-open');
        $('.bg-overlay').addClass('show');
        $(target).addClass('open');
    });

    $('.bg-overlay').click(function (e) {
        $('.modal-menu').removeClass('open');
        $(this).removeClass('show');
        $('html').removeClass('modal-open');
    });
    $('.menu-close').click(function (e) {
        $('.modal-menu').removeClass('open');
        $('.bg-overlay').removeClass('show');
        $('html').removeClass('modal-open');
    });


    // Mobile Menu
    $('.hamburger').click(function () {
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $('html').removeClass('modal-open');
            $('#mobile-menu').removeClass('open');
        } else {
            $(this).addClass('is-active');
            $('html').addClass('modal-open');
            $('#mobile-menu').addClass('open');
        }
    })



    //Slick sliders
    $('.prods-slider').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        prevArrow: $('.feat-arr-slick-prev'),
        nextArrow: $('.feat-arr-slick-next'),
        customPaging: function (slider, i) {
            return '<span class="dot"><i class="fas fa-circle"></i></span>';
        },
        responsive: [{
            breakpoint: 992,
            settings: {
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    });


    if ($('body').hasClass('home')) {
        $('.new-prods_slider').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            rows: 1,
            prevArrow: $('.new-arr-slick-prev'),
            nextArrow: $('.new-arr-slick-next'),
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });

        $('.new-prods_slider_mob').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            rows: 1,
            arrows: true,
            prevArrow: $('.new-arr-slick_prev_mob'),
            nextArrow: $('.new-arr-slick_next_mob'),
        });

        $('.best_sellers-slider').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            rows: 1,
            prevArrow: $('.seller-arr-slick-prev'),
            nextArrow: $('.seller-arr-slick-next'),
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });

        $('.best_sellers-slider-mob').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            rows: 1,
            arrows: true,
            prevArrow: $('.seller-arr-slick-prev_mob'),
            nextArrow: $('.seller-arr-slick-next_mob'),
        });

        $('.collections-slider').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            rows: 1,
            prevArrow: $('.collections-slick-prev'),
            nextArrow: $('.collections-slick-next'),
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });

        $('.collections-slider-mob').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            rows: 1,
            prevArrow: $('.collections-slick-prev_mob'),
            nextArrow: $('.collections-slick-next_mob'),
        });


        $('.latest_slide').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            prevArrow: $('.latest-arr-slick-prev'),
            nextArrow: $('.latest-arr-slick-next'),
            rows: 1,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }]
        });

        $('.latest-offers-slider-mob').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            rows: 1,
            prevArrow: $('.latest-arr-slick-prev_mob'),
            nextArrow: $('.latest-arr-slick-next_mob'),
        });


    }


    //Accordions
    $('.accordion .toggle').click(function (e) {
        e.preventDefault();
        var $this = $(this);
        if ($this.parents('.accordion').find('.inner').hasClass('show')) {
            $this.parents('.accordion').find('.inner').removeClass('show');
            $this.parents('.accordion').find('.inner').slideUp(350);
            $this.parents('.accordion').removeClass('open');
            $this.find('span').html('<i class="fal fa-chevron-down text-grey"></i>');

        } else {
            $this.parents('.accordion').find('.inner').addClass('show');
            $this.parents('.accordion').find('.inner').slideDown(350);
            $this.parents('.accordion').addClass('open');
            $this.find('span').html('<i class="fal fa-chevron-up text-white"></i>');
        }
    });

    if ($('body').hasClass('single-product')) {
        //Single products accordion
        $('.accordion_prods .toggle').click(function (e) {
            e.preventDefault();
            var $this = $(this);
            if ($this.parents('.accordion_prods').find('.inner').hasClass('show')) {
                $this.parents('.accordion_prods').find('.inner').removeClass('show');
                $this.parents('.accordion_prods').find('.inner').slideUp(350);
                $this.parents('.accordion_prods').removeClass('open');
                $this.find('span').html('<i class="fal fa-chevron-down"></i>');

            } else {
                $this.parents('.accordion_prods').find('.inner').addClass('show');
                $this.parents('.accordion_prods').find('.inner').slideDown(350);
                $this.parents('.accordion_prods').addClass('open');
                $this.find('span').html('<i class="fal fa-chevron-up"></i>');
            }
        });

        $('.rel-prods-slider').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            prevArrow: $('.rel-prods-slick-prev'),
            nextArrow: $('.rel-prods-slick-next'),
        });

        $('.rel-prods-slider-mob').slick({
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            prevArrow: $('.rel-prods-slick-prev_mob'),
            nextArrow: $('.rel-prods-slick-next_mob'),
        });

        $('#product-gallery-main').slick({
            autoplay: false,
            dots: false,
            infinite: true,
            speed: 500,
            pauseOnHover: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
            arrows: false,
            cssEase: 'linear',
            adaptiveHeight: false,
            asNavFor: '#product-gallery-thumbs',
            swipe: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    swipe: true,
                    autoplay: true,
                    autoplaySpeed: 3000,
                }
            }]
        });


        $('#product-gallery-main-mob').slick({
            autoplay: false,
            dots: true,
            infinite: false,
            speed: 500,
            pauseOnHover: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: false,
        });


        $('#product-gallery-thumbs').slick({
            autoplay: false,
            dots: false,
            infinite: true,
            speed: 500,
            pauseOnHover: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            cssEase: 'linear',
            asNavFor: '#product-gallery-main',
            focusOnSelect: true,
        });
    }
    //WOOCOMMERCE STARTS HERE


    // CATEGORY SCRIPTS

    if ($('body').hasClass('tax-product_cat') || $('body').hasClass('post-type-archive-product') || $('body').hasClass('search-results') || $('body').hasClass('woocommerce-page') || !$('body').hasClass('page-template-basket') || !$('body').hasClass('woocommerce-checkout')) {

        // Set Brand

        $('.brand-filter-list .micro-filter').on('click', function () {

            brands = [];
            $(this).toggleClass('active');

            $('.brand-filter-list .micro-filter.active').each(function () {
                brands.push($(this).data('brand'));
            });

            if (brands.length < 1) {
                var brands = 'all';
            } else {
                var brands = brands.toString();
            }

            $('.brand-filter').val(brands);

        });


        // Set Conditions

        $('.condition-filter-list .micro-filter').on('click', function () {

            // Make All Others Inactive and Clicked one Active/Inactive

            $('.condition-filter-list .micro-filter').not(this).removeClass('active');
            $(this).toggleClass('active');

            if ($(this).data('condition') == $('.condition-filter').val()) {
                var condition = 'all';
            } else {
                var condition = $(this).data('condition');
            }

            $('.condition-filter').val(condition);

        });


        // Set Categories

        $('.category-filter-list .micro-filter').on('click', function () {

            // Make All Others Inactive and Clicked one Active/Inactive

            $('.category-filter-list .micro-filter').not(this).removeClass('active');
            $(this).toggleClass('active');

            if ($(this).data('category') == $('.category-filter').val()) {
                var category = 'all';
            } else {
                var category = $(this).data('category');
            }

            $('.category-filter').val(category);

            //console.log( $('.category-filter').val() );
            //console.log( $(this).data('category') );

        });



        // Set Minimum Rating

        $('.filter .rating svg').on('click', function () {
            console.log('clicked');

            var minimum_rating = $(this).data('minimum-rating');

            $('.minimum-rating .clear').addClass('active');

            if (minimum_rating == '1') {

                $('.star-1').addClass('active');
                $('.star-2, .star-3, .star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '2') {

                $('.star-1, .star-2').addClass('active');
                $('.star-3, .star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '3') {

                $('.star-1, .star-2, .star-3').addClass('active');
                $('.star-4, .star-5').removeClass('active');

            } else if (minimum_rating == '4') {

                $('.star-1, .star-2, .star-3, .star-4').addClass('active');
                $('.star-5').removeClass('active');

            } else if (minimum_rating == '5') {

                $('.star-1, .star-2, .star-3, .star-4, .star-5').addClass('active');

            }

            $('.minimum-rating-filter').val(minimum_rating);

        });

        // Clear Minimum Rating

        $('.minimum-rating .clear').on('click', function () {
            $('.star-1, .star-2, .star-3, .star-4, .star-5').removeClass('active');
            $('.minimum-rating-filter').val(0);
            $(this).removeClass('active');
        });

        // Set Lower Price

        $('.filter .price-lower').on('change', function () {
            var price_lower = $(this).val();
            $('.price-filter-lower').val(price_lower)
        });

        // Set Upper Price

        $('.filter .price-upper').on('change', function () {
            var price_upper = $(this).val();
            $('.price-filter-upper').val(price_upper)
        });

        // Isotope Filter and Grid
        $('.brand-filter-list .micro-filter, .condition-filter-list .micro-filter, .category-filter-list .micro-filter, .filter .minimum-rating svg, .minimum-rating .clear').on('click', function () {
            filter();
        });

        $('.filter .price-lower, .filter .price-upper').on('change', function () {
            filter();
        });

        //hiding unused data brand
        $('*[data-data="obagi-new-derm"]').hide();

    }

    // WRITE A REVIEW SCRIPTS   

    if ($('body').hasClass('page-template-write_review')) {

        if ($('.gform_confirmation_message').length < 1) {

            $('.gform_fields').addClass('overflow-hidden')
            $('.gfield, .gform_footer').addClass('row g-0 pt-10 pt-lg-20 pb-10 pb-lg-15');
            $('.gfield .gfield_label').addClass('col-lg-4 fs-18 lh-100');
            $('.gfield .ginput_container').addClass('col-lg-8');
            $('.gfield input, .gfield textarea').addClass('bf2-400 fs-12 fs-lg-14');
            $('.gform_button').addClass('btn  w-100 text-center pt-0 pl-0 pr-0 pb-0').wrap('<div class="col-lg-4 offset-lg-4"></div>');

            $('.rating').prependTo('.review_rating .ginput_container');
            $('.review_rating input').addClass('d-none');

        } else {

            $('.rating').remove();
            $('.gform_confirmation_message').addClass('w-100 w-lg-50 mx-auto text-center');

        }

        $(document).on('click', '.review_rating .rating svg', function () {

            var rating = $(this).data('rating');

            if (rating == '1') {

                $('.star-1').addClass('active');
                $('.star-2, .star-3, .star-4, .star-5').removeClass('active');

            } else if (rating == '2') {

                $('.star-1, .star-2').addClass('active');
                $('.star-3, .star-4, .star-5').removeClass('active');

            } else if (rating == '3') {

                $('.star-1, .star-2, .star-3').addClass('active');
                $('.star-4, .star-5').removeClass('active');

            } else if (rating == '4') {

                $('.star-1, .star-2, .star-3, .star-4').addClass('active');
                $('.star-5').removeClass('active');

            } else if (rating == '5') {

                $('.star-1, .star-2, .star-3, .star-4, .star-5').addClass('active');

            }

            $('.review_rating input').val(rating);

        });

    }



    // On Page Load
    $(window).on('load', function () {

        var $grid = $('.category-grid').isotope({
            itemSelector: '.category-product',
            layoutMode: 'fitRows',
        });

        // layout Isotope after each image loads
        $grid.imagesLoaded().progress(function () {
            $grid.isotope('layout');
        });
        // Header Scroll
        var offsetTopPosition = $('.header_trigger').offset().top - $(window).scrollTop(),
            fixed_bar = $('.frame__top');
        if ($('body').hasClass('page-template-home')) {

            if (wSize >= 992) {
                if ($(this).scrollTop() > 80) {
                    $(fixed_bar).addClass('scrolled');
                } else {
                    $(fixed_bar).removeClass('scrolled');
                }
            }
        }

    });

});

